// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-313926b0]{text-decoration:underline;font-weight:600;display:inline-block;border-radius:.25rem;border-color:transparent;border-bottom-width:2px;border-bottom-right-radius:0;border-bottom-left-radius:0;padding-top:.25rem;padding-bottom:.25rem}a[data-v-313926b0]:hover{--text-opacity:1;color:#bee3f8;color:rgba(190,227,248,var(--text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
